import React, { FC } from 'react';
import { compose } from 'react-recompose';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { AlreadyActivatedUser } from '@dev/ee-modules';
import { ProductCode } from '@dev/ee-api/ee-api-models';

import { push } from 'redux-first-history';
import useMobile from '../../services/hooks/useMobile';
import { HomePaths } from '../../services/dictionaries/Paths';
import { ApplicationState as State } from '../../store';
import { RegisterActivatedUserProps } from './RegisterActivatedUserInterface';

const mapState = (state: State, ownProps: RegisterActivatedUserProps): RegisterActivatedUserProps => ownProps;

const dispatchProps = {
    Push: push,
};

interface DispatchProps {
    Push(url: string): void;
}

type ExtendedProps = RegisterActivatedUserProps & DispatchProps;

const RegisterActivatedUser: FC<ExtendedProps> = (props: ExtendedProps): JSX.Element => {
    const isMobile = useMobile();
    return (
        <AlreadyActivatedUser
            paths={{ Login: HomePaths.Login }}
            isMobile={isMobile}
            productCode={ProductCode.Legacy}
            {...props}
        />
    );
};

export default compose(
    withTranslation(),
    connect<RegisterActivatedUserProps, DispatchProps>(mapState, dispatchProps)
)(RegisterActivatedUser);
